import React from 'react';

import {
  DailyStatusCounts,
  IAlarmCountStatistics,
  IDashboardLayoutProps,
  IEfficiencyTrend,
  ISellerUtilization,
  IStatusRate,
} from '@models/home';
import LongTermView from '@pages/Home/layouts/ChargingEquipmentStability/components/LongTermView';
import RealtimeView from '@pages/Home/layouts/ChargingEquipmentStability/components/RealtimeView';

import './ChargingEquipmentStability.scss';
import '../BaseLayout.scss';

export const URL = {
  SAAS_UTILIZATION:
    '/api/statistics-service/operationView/getSellerUtilization',
  SAAS_STATUS_RATE:
    '/api/statistics-service/operationView/getSellerEquipmentServiceStatusRate',
  ALARM_COUNT_STATISTICS:
    '/api/statistics-service/operationView/getSellerAlarmCountStatistics',
  SAAS_EFFICIENCY_TREND:
    '/api/statistics-service/operationView/getSellerChargingEfficiency',
};

export const initSellerUtilization: ISellerUtilization = {
  timeList: [],
  maximumMinutesMap: [],
  normalOperationMinutesMap: [],
  utilizationMap: [],
};

export const initStatusRate: IStatusRate = {
  timeList: [],
  dailyStatusCounts: [
    {
      totalChargingGunCount: 0,
      totalFaultedGunCount: 0,
      totalAvailableGunCount: 0,
      totalHoggingGunCount: 0,
      totalReservedGunCount: 0,
      totalGunCount: 0,
      totalOfflineGunCount: 0,
      totalUnavailableGunCount: 0,
    },
  ],
};

export const initAlarmStatistics: IAlarmCountStatistics = {
  totalGunCountList: [],
  highSeverityCountList: [],
  mediumSeverityCountList: [],
  lowSeverityCountList: [],
  timeList: [],
};

export const initEfficiencyTrend: IEfficiencyTrend = {
  timeList: [],
  efficiency: [],
  pileOutputPowers: [],
  pileMaxmunPowers: [],
};

export const serviceStatusRateDataOrder: {
  key: keyof DailyStatusCounts;
  name: string;
  color: string;
}[] = [
  {
    key: 'totalAvailableGunCount',
    name: 'ChargingEquipmentStability.Available',
    color: '#2068F6',
  },
  {
    key: 'totalChargingGunCount',
    name: 'ChargingEquipmentStability.Charging',
    color: '#6FD29F',
  },
  {
    key: 'totalHoggingGunCount',
    name: 'ChargingEquipmentStability.InUse',
    color: '#F7C55D',
  },
  {
    key: 'totalFaultedGunCount',
    name: 'ChargingEquipmentStability.Faulted',
    color: '#F19B5B',
  },
  {
    key: 'totalUnavailableGunCount',
    name: 'ChargingEquipmentStability.Disabled',
    color: '#FE7274',
  },
  {
    key: 'totalReservedGunCount',
    name: 'ChargingEquipmentStability.Reserved',
    color: '#B877F9',
  },
  {
    key: 'totalOfflineGunCount',
    name: 'ChargingEquipmentStability.Offline',
    color: '#E4E7EC',
  },
];

function ChargingEquipmentStability({
  activeTab, // 現在選擇的 tab
  activeLongTermOption, // 長期資訊中的時間區間
}: IDashboardLayoutProps) {
  return (
    <div className="BaseLayout">
      {activeTab === 'immediate' && <RealtimeView />}
      {activeTab === 'longTerm' && (
        <LongTermView longTermOption={activeLongTermOption} />
      )}
    </div>
  );
}

export default ChargingEquipmentStability;
